import React, {useRef} from 'react';
import {useState} from 'react';
import {View, Text} from 'react-native';
import FastImage from 'src/Utils/FastImage';
import {Marker, MapViewCluster} from 'src/Modules/Native/MapView';

import {useDispatch, useSelector} from 'react-redux';

import {updateSelectedLocalLocationId} from '../Redux/reducers/local.reducer';
import Stars from 'src/Modules/CommonView/Stars';
import {logCustomAnalyticsEvent} from '../Utils/fireUtils';
import {getReduxState} from '../Utils/helpers';
import {navigationRef} from '../Nav/navigationHelpers';

const LocalMap = () => {
  // console.log({MapViewCluster, Marker});
  const localLocationsList = useSelector(
    (state) => state.local.localLocationsList,
  );

  const region = useSelector((state) => state.location.region);
  const {latitude, longitude} = region;

  const INITIAL_REGION = {
    latitude: 1.0 * (latitude || 0),
    longitude: 1.0 * (longitude || 0),
    latitudeDelta: 3,
    longitudeDelta: 3,
  };

  const mapRef = useRef();

  const [isZoomed, setIsZoomed] = useState(false);

  console.log({isZoomed});

  return (
    <MapViewCluster
      key={latitude != 37.78825 && longitude != -122.4324 ? 1 : 0}
      initialRegion={INITIAL_REGION}
      showsUserLocation
      showsPointsOfInterest={false}
      minPoints={1}
      animationEnabled={0}
      onRegionChange={(region) => {
        const {latitudeDelta} = region;
        const newIsZoomed = latitudeDelta < 2;

        if (newIsZoomed != isZoomed) {
          console.log({newIsZoomed, isZoomed, latitudeDelta});
          setIsZoomed(newIsZoomed);
          // Alert.alert('hi' + region.latitudeDelta);
        }
      }}
      customMapStyle={[
        {
          featureType: 'administrative',
          elementType: 'geometry',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'poi',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
        {
          featureType: 'transit',
          stylers: [
            {
              visibility: 'off',
            },
          ],
        },
      ]}
      // provider={PROVIDER_APPLE}
      ref={mapRef}
      style={{flex: 1}}
      // initialRegion={{
      //   latitude: latitude || 0,
      //   longitude: longitude || 0,
      //   latitudeDelta: 0.3,
      //   longitudeDelta: 0.3,
      // }}
    >
      {localLocationsList?.map?.((location) => {
        var {id, lat, long} = location;
        if (isNaN(lat) || isNaN(long)) {
          return;
        }
        lat = Number(lat);
        long = Number(long);

        return (
          <LocalMarker
            key={id + '' + isZoomed}
            coordinate={{latitude: lat, longitude: long}}
            mapRef={mapRef}
            isZoomed={isZoomed}
            location={location}
          />
        );
      })}
    </MapViewCluster>
  );
};

const LocalMarker = ({coordinate, mapRef, isZoomed = false, location}) => {
  const {latitude, longitude} = coordinate;

  const dispatch = useDispatch();

  // Alert.alert(location.photo);
  return (
    <Marker
      coordinate={coordinate}
      onPress={() => {
        if (!isZoomed) {
          return mapRef.current?.animateToRegion({
            latitude: parseFloat(latitude || 1),
            longitude: parseFloat(longitude || 1),
            latitudeDelta: 0.2,
            longitudeDelta: 0.2,
          });
        } else {
          dispatch(updateSelectedLocalLocationId(location.id));
          const userId = getReduxState(['user', 'userId']);
          logCustomAnalyticsEvent('local_spot_view', {...location, userId});
          navigationRef.navigate('LocalSiteModal');
        }
      }}>
      {isZoomed && (
        <View
          style={{
            // width: 25,
            // height: 42,
            display: 'flex',
            position: 'relative',
            alignItems: 'center',
            flexDirection: 'row',
            backgroundColor: 'white',
            padding: 4,
            borderRadius: 10,
          }}>
          <FastImage
            source={{uri: location.photo}}
            style={{height: 20, width: 20, borderRadius: 10}}></FastImage>
          <View>
            <Text style={{marginLeft: 10, fontSize: 12, maxWidth: 100}}>
              {location?.title} <Stars size={10} rating={location.rating} />
            </Text>
          </View>
        </View>
      )}
    </Marker>
  );
};

export default LocalMap;
